// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconArrowUp.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconArrowUp = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 9" fill="currentColor" { ...props }>
    <path d="M0.252653 8.74131C-0.0842178 8.39639 -0.0842178 7.83722 0.252653 7.4923L7.31743 0.258695C7.50435 0.0673109 7.75571 -0.0178487 8 0.00310326C8.24429 -0.0178487 8.49565 0.0673109 8.68257 0.258695L15.7473 7.4923C16.0842 7.83722 16.0842 8.39639 15.7473 8.74131C15.4105 9.08623 14.8643 9.08623 14.5274 8.74131L8 2.05797L1.47257 8.74131C1.1357 9.08623 0.589524 9.08623 0.252653 8.74131Z" />
  </BaseIcon>
);

export default IconArrowUp;
